import type { IAccountNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createAccountNote,
  updateNote: updateAccountNote,
  deleteNote: deleteAccountNote,
} = makeNoteService<IAccountNote>('/api/accountnotes', 'accountNote')
